export default {
    greeting: 'Willkommen beim Sedho-Login',
    language_choose: 'Sprache wählen',
    languages: {
        german: 'Deutsch',
        english: 'Englisch',
    },
    menue: {
        admin: 'Administration',
    },
    submenu: {
        user: 'Nutzer',
    }    
  };